const Header = ()=>{
    return(
        <header>
            <h1>To-Do List Application</h1>
        </header>
    );
}

export default Header;